// Entry point file for the application
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Get the root element to render into
const container = document.getElementById('app');

// Create a root using React 19's createRoot API
const root = createRoot(container);

// Render the application with StrictMode
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
